import { FacilitySortOption } from '@rematter/frontend-lib-api-client';

import { createQueryHook } from '~/shared/providers/api';

export type Facility = {
  id: string;
  facilityName: string;
  address?: {
    streetAddress: string;
    city: string;
    state: string;
    country: string;
    postalCode: string;
  };
};

export const useFacilitiesQuery = createQueryHook(
  'transportation.facilities',
  (params: {
    searchTerm?: string;
    sorting?: FacilitySortOption[];
    limit?: number;
    offset?: number;
    facilityGroupId?: string;
  }) => ({
    facilities: {
      __args: {
        filter: {
          ...(params.searchTerm ? { searchTerm: params.searchTerm } : {}),
          ...(params.facilityGroupId
            ? { facilityGroupId: params.facilityGroupId }
            : {}),
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        __typename: true,
        id: true,
        facilityName: true,
        address: {
          __scalar: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { facilities: Facility[]; total: number | undefined } => ({
      facilities:
        data?.facilities.entries.map((facility) => ({
          id: facility.id,
          facilityName: facility.facilityName,
          address: facility.address
            ? {
                streetAddress: facility.address.streetAddress,
                city: facility.address.city,
                state: facility.address.state,
                country: facility.address.country,
                postalCode: facility.address.postalCode,
              }
            : undefined,
        })) ?? [],
      total: data?.facilities.page.total ?? undefined,
    }),
  },
);
